import { Venmo } from './components/Venmo/Venmo';
import { useCheckout } from '../../../../hooks/use-checkout';
import { EBEPaymentMethodsName } from '../../../../contracts';
import { BraintreeCardContainer } from './components/BraintreeCardContainer/BraintreeCardContainer';

export function BraintreePayment() {
  const { selectedPaymentMethod } = useCheckout();

  if (selectedPaymentMethod?.paymentMethodName === EBEPaymentMethodsName.venmo) {
    return <Venmo />;
  }

  if (selectedPaymentMethod?.paymentMethodName === EBEPaymentMethodsName.card) {
    return <BraintreeCardContainer />;
  }

  return null;
}
